import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { ProductInAllStores } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { Container, Row } from "react-bootstrap";
import "../../styles/viewCustomer.css";

const ViewInventory = () => {
  const navigate = useNavigate();
  const { currentColor, userID, userToken } = useStateContext();
  const [AllProductInStore, setAllProductInStore] = useState([]);
  const [ProductName, setProductName] = useState("");
  let param = useParams();

  const InventoryGrid = [
    //{ type: 'checkbox', width: '50' },

    { field: "store", headerText: "Store", width: "240", textAlign: "left" },

    {
      field: "unit_instock",
      headerText: "Stk Qty",
      width: "100",
      textAlign: "right",
    },

    { field: "unit", headerText: "Unit", width: "120", textAlign: "left" },

    {
      field: "min_stock",
      headerText: "Min Stk",
      width: "120",
      textAlign: "right",
    },

    {
      field: "max_stock",
      headerText: "Max Stk",
      width: "120",
      textAlign: "right",
    },

    {
      field: "opening_balance",
      headerText: "Open Bal",
      // template: customerGridImage1,
      width: "120",
      textAlign: "right",
    },
    // {
    //   field: "note",
    //   headerText: "Note",
    //   // template: customerGridImage1,
    //   width: "150",
    //   textAlign: "Center",
    // },
  ];
  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    try {
      // console.log("Back");
      navigate("/Inventory");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //   const handleRowSelected = (args) => {
  //     const selectedRowData = args.data;
  //     setCode(selectedRowData.code);
  //     console.log(selectedRowData.code);
  //     // console.log('Selected Product Code:', productcode);
  //   };

  useEffect(() => {
    if (param.p_id && userID && userToken) {
      TimeoutUtility.resetTimeout();
      //console.log("id "+param.p_id);
      const resp = ProductInAllStores(param.p_id, userID, userToken);
      resp
        .then(function (result) {
          setAllProductInStore(result.data);
          setProductName(result.data[0].code + " - " + result.data[0].name);
          //console.log(result);
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  }, [param.p_id, userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="PRODUCT INVENTORY" />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <label className="label" style={{ fontSize: "18px" }}>
            Product: {ProductName}
          </label>
          <Row md={"auto"} className="justify-content-end">
            <Button
              margin="6px"
              color="white"
              bgColor={currentColor}
              text="Back"
              borderRadius="10px"
              onClick={handleBackClick}
            />
          </Row>

          <GridComponent
            className="custom-grid"
            dataSource={AllProductInStore}
            allowPaging={true}
            pageSettings={{
              pageSize: 16,
              pageSizes: [16, 48, 100, "All"],
            }}
            height="calc(62vh - 60px)"
            allowSorting
            allowResizing
            allowTextWrap={true}
            toolbar={["Search"]}
            rowHeight={36}
          >
            {/* rowSelected={handleRowSelected} */}
            <ColumnsDirective>
              {InventoryGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject
              services={[Resize, Page, Toolbar, Selection, Edit, Sort, Filter]}
            />
          </GridComponent>
        </Container>
      </form>
      {/* <button onClick={handleSubmit}>Submit</button> */}
    </div>
  );
};

export default ViewInventory;
